/**
 * CustomPromptAction Component
 * Action button for custom AI prompts. Opens a modal instead of dropdown.
 *
 * Usa ActionChip para herdar o mesmo padrao visual das outras acoes (cor
 * de fundo, hover, estado desativado/processando). Antes essa acao tinha
 * estilos proprios e divergia visualmente da Traduzir/Resposta Rapida.
 */
import React, { useState } from 'react';
import { MessageSquarePlus } from 'lucide-react';
import ActionChip from '../ActionChip';
import { ACTION_TYPES, ACTIONS_CONFIG } from '../constants';
import CustomPromptModal from './CustomPromptModal';

const CustomPromptAction = ({
  onExecute,
  isProcessing = false,
  selectedMessagesPreview = [],
  isCompact = false, // eslint-disable-line no-unused-vars
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const config = ACTIONS_CONFIG[ACTION_TYPES.CUSTOM];

  const handleClick = () => {
    if (isProcessing) return;
    setIsModalOpen(true);
  };

  const handleClose = () => setIsModalOpen(false);

  const handleSubmit = async (payload) => {
    setIsModalOpen(false);
    const prompt = typeof payload === 'string' ? payload : payload?.prompt;
    const files = typeof payload === 'string' ? [] : (payload?.files || []);
    await onExecute?.(prompt, files);
  };

  return (
    <>
      <ActionChip
        icon={MessageSquarePlus}
        label={config.label}
        isActive={isModalOpen}
        isProcessing={isProcessing}
        processingLabel="Gerando..."
        hasDropdown={false}
        onClick={handleClick}
      />

      <CustomPromptModal
        isOpen={isModalOpen}
        onClose={handleClose}
        onSubmit={handleSubmit}
        isProcessing={isProcessing}
        selectedMessagesPreview={selectedMessagesPreview}
      />
    </>
  );
};

export default CustomPromptAction;
